import React from 'react';
import { MotifIcon, MotifIconButton, MotifTooltip } from '@ey-xd/motif-react';
import { IconoirEditPencil, IconoirTrash } from '@ey-xd/motif-icon';

// Determine if the delete button should be disabled
function isDeleteDisabled(data) {
  const periodsExist = Array.isArray(data?.periods) && data.periods.length > 0;
  const dep = data?.reitDependentEntityData || {};

  return (
    periodsExist ||
    dep.checklistDeliveryScheduleExists === true ||
    dep.propertyMasterExists === true ||
    dep.trsMasterExists === true ||
    dep.securitiesMasterExists === true
  );
}

// Render delete button with tooltip if REIT cannot be deleted
function renderDeleteButton(props, onDeleteClick) {
  const preventDeleteREIT = isDeleteDisabled(props.data);

  const deleteButton = (
    <MotifIconButton
      aria-label="Delete this REIT"
      type="button"
      onClick={onDeleteClick}
      data-testid="btnDeleteREIT"
      disabled={preventDeleteREIT}
    >
      <MotifIcon
        iconFunction={IconoirTrash}
        size="24"
        title="Delete this REIT"
      />
    </MotifIconButton>
  );

  if (preventDeleteREIT) {
    return (
      <MotifTooltip
        trigger={deleteButton}
        allowClick={false}
        hideCloseButton={true}
      >
        {
          'The REIT is not available for deletion because it may have one or more report periods and/or other master data'
        }
      </MotifTooltip>
    );
  }

  return deleteButton;
}

export default (props) => {
  const onEditClick = () => {
    props.handleEditButtonClick(props.data);
  };
  const onDeleteClick = () => {
    props.handleDeleteButtonClick(props.data);
  };

  let threshold =
    props.data.percentageThreshold + '% / $' + props.data.balanceThreshold;
  let isREITActive = props.data.isActive === true ? 'Yes' : 'No';

  return (
    <div>
      {props.column.colId == 'percentageThreshold' && threshold}
      {props.column.colId == 'isActive' && isREITActive}
      {props.column.colId === 'editactions' && (
        <span className="mt-3">
          <MotifIconButton
            aria-label="Edit this REIT"
            type="button"
            data-testid="btnEditREIT"
            onClick={onEditClick}
          >
            <MotifIcon
              iconFunction={IconoirEditPencil}
              size="24"
              title="Edit this REIT"
            />
          </MotifIconButton>
        </span>
      )}

      {props.column.colId === 'deleteactions' && (
        <span className="mt-3">{renderDeleteButton(props, onDeleteClick)}</span>
      )}
    </div>
  );
};
